export var ChartType;
(function (ChartType) {
    ChartType["Bar"] = "Bar";
    ChartType["Line"] = "Line";
})(ChartType || (ChartType = {}));
